import React from "react";
import axios from "axios";
import { CircularProgress, Dialog, DialogContent, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";
import Button from "../../../components/CustomButtons/Button";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import PartialRefund from "./PartialRefund";
import ConfirmRefund from "./ConfirmRefund";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import { toast } from "react-toastify";
import { format } from "date-fns";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class PaymentDetails extends React.Component {
  emailInput = React.createRef();

  state = {
    saving: false,
    bestelling: {},
    loading: true,
    canSendEmail: false,
    refunding: false,
    partialRefundModal: false,
    confirmRefund: false,
  };

  applyCurrencyConversion = [
    "totalRegistered",
    "totalShopperPending",
    "totalAcquirerPending",
    "totalAcquirerApproved",
    "totalCaptured",
    "totalRefunded",
    "totalChargedback",
    "totalReversed",
    "_",
    "amount",
    "settlementAmount",
    "amountRefunded",
    "amountRemaining",
    "amountChargedBack",
  ];

  applyDateConversion = [
    "modifiedDate",
    "date",
    "exchangeRateDate",
    "createdAt",
    "paidAt",
    "canceledAt",
    "expiresAt",
    "failedAt",
    "dueDate",
  ];
  logicalConversion = ["apiInformation.conversionApplied", "consideredSafe.value"];

  replaceMapCM = {
    totalRegistered: "Registered",
    approximateTotals: "Totals",
    totalShopperPending: "Shopper pending",
    totalAcquirerPending: "Acquirer pending",
    totalAcquirerApproved: "Acquirer approved",
    totalCaptured: "Captured",
    totalRefunded: "Refunded",
    totalChargedback: "Chargeback",
    totalReversed: "Reversed",
    _: "Value",
    payment: "Payment info",
    confidenceLevel: "Confidence level",
    paymentMethod: "Method",
    exchangedTo: "Exchanged to",
    exchangeRateDate: "Exchanged date",
    authorization: "Authorization",
    riskChecks: "Risk",
    id: "ID",
    score: "Score",
    amount: "Amount",
    status: "Status",
    currency: "Currency",
    refund: "Refunded",
    modifiedDate: "Date",
    cardHolder: "Holder",
    cardCountry: "Country",
    panLast4: "Last 4",
    extended: "Extended info",
    consideredSafe: "Payment safe",
    capture: "Capture info",
    value: "Value",
    visaPaymentInfo: "Card info",
    masterPaymentInfo: "Card info",
    level: "Level",
    date: "Date",
    reason: "Reason",
    apiInformation: "API Info",
    originalVersion: "Version",
    conversionApplied: "Converted",
  };

  replaceMapMOLLIE = {
    resource: "Resource",
    id: "Payment ID",
    amount: "Transaction amount",
    settlementAmount: "Payment amount",
    amountRefunded: "Refunded amount",
    amountRemaining: "Remaining amount",
    amountChargedBack: "Chargeback amount",
    description: "Description",
    method: "Payment method",
    status: "Status",
    createdAt: "Created",
    paidAt: "Paid",
    failedAt: "Failed",
    dueDate: "Due",
    locale: "Language",
    details: "Details",
    amountCaptured: "Capture amount",
    applicationFee: "Transaction fee",
    countryCode: "Country code",
    cardNumber: "Card number",
    consumerName: "Customer",
    consumerAccount: "Account number",
    consumerBic: "Account BIC",
  };

  /*replaceMapMOLLIE = {
    resource: "Resource",
    id: "Payment ID",
    amount: "Transaction amount",
    settlementAmount: "Payment amount",
    amountRefunded: "Refunded amount",
    amountRemaining: "Remaining amount",
    amountChargedBack: "Chargeback amount",
    description: "Description",
    method: "Payment method",
    status: "Status",
    createdAt: "Created",
    paidAt: "Paid",
    failedAt: "Failed",
    dueDate: "Due",
    locale: "Language",
    details: "Details",
    amountCaptured: "Capture amount",
    applicationFee: "Transaction fee",
    countryCode: "Country code",
    cardNumber: "Card number",
    consumerName: "Customer",
    consumerAccount: "Account number",
    consumerBic: "Account BIC",
  };*/

  hideMapMOLLIE = {
    redirectUrl: true,
    webhookUrl: true,
    sequenceType: true,
    profileId: true,
    metadata: true,
    restrictPaymentMethodsToCountry: true,
    _links: true,
    _embedded: true,
    isCancelable: true,
    routing: true,
    authorizedAt: true,
    expiredAt: true,
    customerId: true,
    canceledAt: true,
    expiresAt: true,
    billingEmail: true,
    mandateId: true,
    subscriptionId: true,
    settlementId: true,
    orderId: true,
    mode: true,
    locale: true,
  };

  replaceMapPayNL = {
    id: "Payment ID",
    orderId: "Order ID",
    serviceCode: "Service code",
    amount: "Transaction amount",
    amountPaid: "Payment amount",
    amountConverted: "Amount converted",
    paymentData: "Payment data",
    intergration: "Intergration",
    description: "Description",
    method: "Payment method",
    status: "Status",
    createdAt: "Created",
    paidAt: "Paid",
    failedAt: "Failed",
    dueDate: "Due",
    locale: "Language",
    details: "Details",
    value: "Value",
    amountCaptured: "Capture amount",
    applicationFee: "Transaction fee",
    countryCode: "Country code",
    cardNumber: "Card number",
    consumerName: "Customer",
    consumerAccount: "Account number",
    consumerBic: "Account BIC",
  };

  hideMapPayNL = {
    redirectUrl: true,
    webhookUrl: true,
    sequenceType: true,
    profileId: true,
    metadata: true,
    restrictPaymentMethodsToCountry: true,
    _links: true,
    _embedded: true,
    isCancelable: true,
    routing: true,
    authorizedAt: true,
    expiredAt: true,
    customerId: true,
    canceledAt: true,
    expiresAt: true,
    billingEmail: true,
    mandateId: true,
    subscriptionId: true,
    settlementId: true,
    orderId: true,
    mode: true,
    locale: true,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && prevProps.open !== this.props.open) {
      this.loadBestelling();
    }

    if (this.props.open === false && prevProps.open !== this.props.open) {
      this.setState({ loading: true });
    }
  }

  loadBestelling = () => {
    axios.get("core/payments/" + this.props.bestellingId).then((response) => {
      this.setState({ bestelling: response.data.data, loading: false }, () => {
        this.setState({ refunding: false });
      });
    });
  };

  hideOrder = () => {
    axios.get("core/bestellingen/" + this.props.bestellingId).then((response) => {
      this.setState({ bestelling: response.data.data, loading: false });
    });
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleRefund = () => {
    this.setState({ refunding: true, handleRefundConfirm: false }, () => {
      axios
        .post("core/payments/refund", {
          id: this.props.bestellingId,
          hash: this.state.bestelling.orderHash,
        })
        .then((response) => {
          toast.success("Payment refunded.");
          this.loadBestelling();
          this.props.refreshJamezzTable();
        })
        .catch((xhr) => {
          console.log(xhr);
          toast.error("Payment refund failed.");
        });
    });
  };

  handlePartialRefund = () => {
    this.setState({
      partialRefundModal: true,
    });
  };

  handleRefundConfirm = () => {
    this.setState({
      handleRefundConfirm: true,
    });
  };

  /**
   * Get financial format
   */
  getNumberformat(value, currency = "EUR") {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency.toUpperCase(),
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  renderRecursive = (startObject, first = true, parentName = "", paymentProvider = "") => {
    let resultItems = [];
    switch (paymentProvider.toLocaleLowerCase()) {
      case "cm":
        for (const keyId in startObject) {
          let renderItem = true;
          if (typeof startObject[keyId] === "object") {
            let spacing = {};
            if (first) {
              spacing = { marginTop: "10px" };
            }
            resultItems.push(
              <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)} style={spacing}>
                <tbody>
                  <tr>
                    <td style={{ width: "160px" }} valign={"top"}>
                      <b>
                        {!first ? "+" : ""} {this.replaceMapCM[keyId] ?? keyId}
                      </b>
                    </td>
                    <td valign={"top"}>{this.renderRecursive(startObject[keyId], false, keyId, paymentProvider)}</td>
                  </tr>
                </tbody>
              </table>
            );
          } else {
            let displayValue = startObject[keyId];
            if (this.applyCurrencyConversion.includes(keyId)) {
              if (parseFloat(displayValue) > 0) {
                displayValue = this.getNumberformat(displayValue / 100, this.state.bestelling.vestiging.valuta);
              } else {
                renderItem = false;
              }
            }
            if (this.applyDateConversion.includes(keyId)) {
              displayValue = format(new Date(displayValue), "dd-MM-yy HH:mm:ss");
            }
            if (this.logicalConversion.includes(parentName + "." + keyId)) {
              if (displayValue) {
                displayValue = "Yes";
              } else {
                displayValue = "No";
              }
            }
            if (renderItem) {
              resultItems.push(
                <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)}>
                  <tbody>
                    <tr>
                      <td style={{ width: "160px" }} valign={"top"}>
                        <b>{this.replaceMapCM[keyId] ?? keyId}</b>
                      </td>
                      <td valign={"top"}>{displayValue}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }
          }
        }
        break;
      case "mollie":
        for (const keyId in startObject) {
          let renderItem = true;
          if (
            typeof startObject[keyId] === "object" &&
            !this.applyCurrencyConversion.includes(keyId) &&
            startObject[keyId]
          ) {
            let spacing = {};
            if (first) {
              spacing = { marginTop: "10px" };
            }
            if (this.hideMapMOLLIE[keyId] == undefined || !this.hideMapMOLLIE[keyId]) {
              resultItems.push(
                <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)} style={spacing}>
                  <tbody>
                    <tr>
                      <td style={{ width: "160px" }} valign={"top"}>
                        <b>
                          {!first ? "+" : ""} {this.replaceMapMOLLIE[keyId] ?? keyId}
                        </b>
                      </td>
                      <td valign={"top"}>{this.renderRecursive(startObject[keyId], false, keyId, paymentProvider)}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }
          } else {
            let displayValue = startObject[keyId];
            if (this.applyCurrencyConversion.includes(keyId)) {
              if (displayValue && displayValue.value !== undefined && parseFloat(displayValue.value) > 0) {
                displayValue = this.getNumberformat(displayValue.value, displayValue.currency);
              } else {
                renderItem = false;
              }
            }
            if (this.applyDateConversion.includes(keyId) && displayValue) {
              displayValue = format(new Date(displayValue), "dd-MM-yy HH:mm:ss");
            }
            if (this.logicalConversion.includes(parentName + "." + keyId)) {
              if (displayValue) {
                displayValue = "Yes";
              } else {
                displayValue = "No";
              }
            }
            if (renderItem && (this.hideMapMOLLIE[keyId] == undefined || !this.hideMapMOLLIE[keyId]) && displayValue) {
              resultItems.push(
                <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)}>
                  <tbody>
                    <tr>
                      <td style={{ width: "160px" }} valign={"top"}>
                        <b>{this.replaceMapMOLLIE[keyId] ?? keyId}</b>
                      </td>
                      <td valign={"top"}>{displayValue}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }
          }
        }
        break;
      case "paynl":
        for (const keyId in startObject) {
          let renderItem = true;
          if (
            typeof startObject[keyId] === "object" &&
            !this.applyCurrencyConversion.includes(keyId) &&
            startObject[keyId]
          ) {
            let spacing = {};
            if (first) {
              spacing = { marginTop: "10px" };
            }
            if (this.hideMapPayNL[keyId] == undefined || !this.hideMapPayNL[keyId]) {
              resultItems.push(
                <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)} style={spacing}>
                  <tbody>
                    <tr>
                      <td style={{ width: "160px" }} valign={"top"}>
                        <b>
                          {!first ? "+" : ""} {this.replaceMapPayNL[keyId] ?? keyId}
                        </b>
                      </td>
                      <td valign={"top"}>{this.renderRecursive(startObject[keyId], false, keyId, paymentProvider)}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }
          } else {
            let displayValue = startObject[keyId];
            if (this.applyCurrencyConversion.includes(keyId)) {
              if (displayValue && displayValue.value !== undefined && parseFloat(displayValue.value) > 0) {
                displayValue = this.getNumberformat(displayValue.value / 100, displayValue.currency);
              } else {
                renderItem = false;
              }
            }
            if (this.applyDateConversion.includes(keyId) && displayValue) {
              displayValue = format(new Date(displayValue), "dd-MM-yy HH:mm:ss");
            }
            if (this.logicalConversion.includes(parentName + "." + keyId)) {
              if (displayValue) {
                displayValue = "Yes";
              } else {
                displayValue = "No";
              }
            }
            if (renderItem && (this.hideMapPayNL[keyId] == undefined || !this.hideMapPayNL[keyId]) && displayValue) {
              resultItems.push(
                <table cellPadding={"0"} cellSpacing={"0"} key={keyId + Math.random(99, 9999)}>
                  <tbody>
                    <tr>
                      <td style={{ width: "160px" }} valign={"top"}>
                        <b>{this.replaceMapPayNL[keyId] ?? keyId}</b>
                      </td>
                      <td valign={"top"}>{displayValue}</td>
                    </tr>
                  </tbody>
                </table>
              );
            }
          }
        }
        break;
      default:
        resultItems.push(<div>No valid Jamezz Payments provider</div>);
        break;
    }
    return resultItems;
  };

  render() {
    const { classes } = this.props;
    var paymentObject = null;
    var refundableAmount = 0;
    this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
      ? (this.state.bestelling.metadata.orderValue * 100 - this.state.bestelling.refunded) / 100
      : 0;
    if (this.state.bestelling.vestiging !== undefined) {
      switch (this.state.bestelling.vestiging.payProvider.toLocaleLowerCase()) {
        case "cm":
          paymentObject =
            this.state.bestelling.paymentDetails && this.state.bestelling.paymentDetails.statusSuccess !== undefined
              ? this.state.bestelling.paymentDetails.statusSuccess.report
              : null;
          refundableAmount =
            this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
              ? (this.state.bestelling.metadata.orderValue * 100 - this.state.bestelling.refunded) / 100
              : 0;
          break;
        case "paynl":
          paymentObject =
            this.state.bestelling.paymentDetails &&
            this.state.bestelling.paymentDetails.status.action !== undefined &&
            this.state.bestelling.paymentDetails.status.action == "PAID"
              ? this.state.bestelling.paymentDetails
              : null;
          refundableAmount =
            this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
              ? this.state.bestelling.metadata.orderValue - this.state.bestelling.refunded
              : 0;
          break;
        case "mollie":
          paymentObject =
            this.state.bestelling.paymentDetails && this.state.bestelling.paymentDetails.status == "paid"
              ? this.state.bestelling.paymentDetails
              : null;
          refundableAmount =
            this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
              ? this.state.bestelling.metadata.orderValue - this.state.bestelling.refunded
              : 0;
          break;
      }
    }

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        {!this.state.loading ? (
          <div>
            <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
              <Button
                aria-label={"Close"}
                className={classes.modalCloseButton}
                color={"transparent"}
                justIcon
                key={"close"}
                onClick={this.props.toggle}
              >
                <Close className={classes.modalClose} />
              </Button>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <img src={"/img/jamezzPayments.png"} style={{ width: "110px", marginTop: "0px" }} />
                    </td>
                    <td>
                      <h1> | #{this.state.bestelling.id}</h1>
                    </td>
                  </tr>
                </tbody>
              </table>
            </DialogTitle>
            {this.state.bestelling.parent_id ? (
              <div align={"center"}>
                <div align={"center"} style={{ color: "red", maxWidth: "80%" }}>
                  <h3 style={{ fontSize: "100%", fontWeight: "600", marginTop: "0px" }}>
                    <TranslationWrapper
                      tDefault={
                        "Pay attention! This payment is part of a partial order, you can only refund the part of the order placed in this partial order."
                      }
                      tKey={"bestellingen.modal.paymentdetail.text.partialPayment"}
                    />
                  </h3>
                </div>
              </div>
            ) : null}
            <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
              {refundableAmount > 0 && !this.state.bestelling.splitOrder ? (
                <GridContainer>
                  <GridItem md={2}>
                    <div style={{ marginTop: "16px" }}>
                      <TranslationWrapper
                        tDefault={"Payment acties"}
                        tKey={"bestellingen.modal.paymentdetail.text.paymentActions"}
                      />
                    </div>
                  </GridItem>
                  <GridItem md={4}>
                    {this.state.refunding ? (
                      <>
                        <CircularProgress
                          style={{
                            width: "30px",
                            height: "30px",
                            position: "relative",
                            top: "10px",
                            marginRight: "10px",
                          }}
                        />
                        <h3
                          style={{
                            fontSize: "100%",
                            fontWeight: "600",
                            marginTop: "0px",
                            display: "inline",
                            color: "#ff0000",
                          }}
                        >
                          Processing refund ...
                        </h3>
                      </>
                    ) : (
                      <Button
                        color={"warning"}
                        disabled={this.state.refunding}
                        onClick={this.handleRefundConfirm}
                        style={{ width: "100%" }}
                      >
                        <>
                          <TranslationWrapper
                            tDefault={"Refund complete payment"}
                            tKey={"bestellingen.modal.paymentdetail.text.refund"}
                          />
                          {this.getNumberformat(refundableAmount, this.state.bestelling.vestiging.valuta)}
                        </>
                      </Button>
                    )}
                  </GridItem>
                </GridContainer>
              ) : null}
              <GridContainer>
                <GridItem md={2}>
                  <TranslationWrapper
                    tDefault={"Payment details"}
                    tKey={"bestellingen.modal.paymentdetail.text.payment"}
                  />
                </GridItem>
                <GridItem md={10}>
                  {this.renderRecursive(paymentObject, true, "", this.state.bestelling.vestiging.payProvider)}
                </GridItem>
              </GridContainer>
            </DialogContent>
          </div>
        ) : (
          <div style={{ margin: "25px auto" }}>
            <CircularProgress />
          </div>
        )}
        <PartialRefund open={this.state.partialRefundModal} toggle={() => this.toggleModal("partialRefundModal")} />
        <ConfirmRefund
          cancel={() => this.toggleModal("handleRefundConfirm")}
          ok={() => {
            // this.toggleModal("handleRefundConfirm");
            this.handleRefund();
          }}
          open={this.state.handleRefundConfirm}
          toggle={() => this.toggleModal("handleRefundConfirm")}
        />
      </Dialog>
    );
  }
}

export default withStyles(PaymentDetails, notificationsStyle);
